module.exports = __webpack_public_path__ + "img/card.de54ba35.png";